export default "__VITE_ASSET__BbeM271Q__"